<template>
  <div class="attachment-detail">
    <template v-if="hasUrl">
      <FilePreview :value="url" />
    </template>

    <template v-else>
      <div v-if="isOrderDetail" class="custom-detail order-detail">
        <el-button type="text" size="small" @click="showRoutePlan()">行程规划</el-button>
        <el-button type="text" size="small" @click="showRouteList()">行程详情</el-button>
        <el-button type="text" size="small" @click="go2QcPage()"><span>质检详情</span></el-button>
      </div>

      <div v-else-if="isRouteDetail" class="custom-detail route-detail">
        <el-button type="text" size="small" @click="showRoutePlan()">行程规划</el-button>
        <el-button type="text" size="small" @click="showRouteList()">行程详情</el-button>
        <el-button type="text" size="small" @click="go2QcPage()"><span>质检详情</span></el-button>
      </div>

    </template>
  </div>
</template>

<script>
import FilePreview from "@/components/FilePreview";
import { SHOW_ROUTE_PLAN } from "@/core/const/global-event";
import Router from "@/route";

export default {
  name: "AttachmentDetail",
  components: { FilePreview },
  props: {
    attachmentType: {
      type: [Number, String],
      default: null
    },
    bizId: {
      type: [Number, String],
      default: null
    },
    url: {
      type: String,
      default: ""
    },



  },
  computed: {
    hasUrl() {
      return this.url && typeof this.url === "string" && this.url.trim().length > 0;
    },
    isOrderDetail() {
      return this.typeConfig.orderTypes.includes(this.attachmentType);
    },
    isRouteDetail() {
      return this.typeConfig.routeTypes.includes(this.attachmentType);
    },

  },
  data() {
    return {
      typeConfig: {
        orderTypes: ["ORDER"],
        routeTypes: ["ROUTE"],
      }
    };
  },

  methods: {
    showRoutePlan() {
      this.$bus.$emit(SHOW_ROUTE_PLAN, { id: this.bizId }, false);
      // this.$emit("close");
    },

    go2QcPage() {
      const { href } = Router.resolve({
        path: "/route/qc",
        query: { routeId: this.bizId }
      });
      window.open(href, "_blank");
    },

    showRouteList() {
      const { href } = Router.resolve({
        path: "/route/list",
        query: { routeId: this.bizId }
      });
      window.open(href, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.attachment-detail {
  width: 100%;
  min-height: 40px;

  .custom-detail {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
  }

  .placeholder {
    color: #c0c4cc;
    font-size: 13px;
  }
}
</style>
